<template>
    <div class="service-wrap pt-20 pb-20">
        <div class="container">
            <!-- TABLEAU SOIRÉES THÉOLOGIQUES -->
             <!-- TABLEAU PARCOURS SPIRITUELS & RETRAITES -->
            <div class="row mb-5">
            <div class="col-12">
                <!-- <h3 class="mb-2">Parcours spirituels et retraites</h3> -->

                <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead class="table-light">
                    <tr>
                        <th>Dates</th>
                        <th>Thèmes</th>
                        <th>Communicateurs</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in parcoursSpirituels" :key="index">
                        <td>{{ item.date }}</td>
                        <td>{{ item.theme }}</td>
                        <td>{{ item.communicateur }}</td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
            </div>



            <div class="row ">
                <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
                    <div class="blog-card style1">
                        <div class="blog-img"  :style="{height:'277px', backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'}"
                        >
                        </div>
                        <div class="blog-info" style="min-height: 250px;">
                            <ul class="blog-metainfo  list-style">
                                <li><i class="flaticon-user"></i> <router-link to="#">L' École d’Initiation Théologique et Pastorale</router-link></li>
                                <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication)  }}</li>
                            </ul>
                            <h3><router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">{{ article.titre }}</router-link></h3>
                            <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }" class="link style1">Lire plus
                                <i class="flaticon-right-arrow"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'LesSoireestheologiques',
    components: {
      PaginationComponent,

  },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const parcoursSpirituels = ref([
  {
    date: "18 et 19 octobre 2025",
    theme: "Les disciples d’Emmaüs : entre désespoir et espérance",
    communicateur: "Père Bernardin BOKO",
  },
  {
    date: "28 au 30 mars 2025",
    theme: "Apprends-nous à prier",
    communicateur: "Père Donatien AMEGEE",
  },
  {
    date: "14 au 15 décembre 2024",
    theme: "Au buisson ardent",
    communicateur: "Sœur Nadine DEGILA",
  },
  {
    date: "06 au 08 septembre 2024",
    theme: "Sur le chemin de Damas",
    communicateur: "Père Félicien KPOFONDE",
  },
  {
    date: "09 et 10 mars 2024",
    theme: "La Samaritaine : guérir de nos blessures (affectives, familiales, culturelles, etc.)",
    communicateur: "Père Beaurice KITI",
  },
  {
    date: "16 et 17 décembre 2023",
    theme: "À Béthel, le combat spirituel : les armes du combat",
    communicateur: "Père Dieudonné N’TCHA",
  },
  {
    date: "08 au 10 septembre 2023",
    theme: "Le choix de Dieu : le sacrifice d’Isaac (Gn 22,1-18)",
    communicateur: "Père Eugène GOUSSIKINDEY",
  },
  {
    date: "31 mars au 02 avril 2023",
    theme: "Seigneur, apprends-nous à prier (Lc 11,1)",
    communicateur: "Père Louis HONDOCODO",
  },
  {
    date: "10 & 11 décembre 2022",
    theme: "L’utilisation de l’écriture dans le travail sur soi / Connaître Dieu et se connaître",
    communicateur: "M. Maurice ANAGONOU / Père Jacob FANOU",
  }
]);



    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/35?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        console.log("fff",articles.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    
    onMounted(() => {
        getTreeArticle();
    });

    return { 
        parcoursSpirituels,
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});
</script>

<style scoped>
    .blog-card .blog-info h3 {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 15px;
    }
</style>